export const GUARDS = {
    ADMINISTRATIVE: 'administrative',
    ADMIN: 'admin',
    ADMINISTRATIVE_2: 'administrative_2',
    BILLSRECEIVE: 'bills-receive', //Contas a receber
    COMMERCIAL: 'commercial', //Head
    DP: 'dp',
    FINANCES: 'finances', //Contas a pagar
    GOVERNANCE: 'governance',
    INFRA: 'infra',
    JUDICIARY: 'judiciary',
    MANAGER: 'manager',
    RS: 'rs',
    CONTROLLERSHIP: 'controllership',
    BUSINESSPARTNER: 'business-partner',
    TECHMANAGEMENT: 'tech-management',
    ACCOUNTMANAGER: 'account-manager',
    PMO: 'pmo',
    ACCOUNTING: 'accounting',
    PEOPLE: 'people',
  }

  export const RULES = {
    [GUARDS.ADMINISTRATIVE]: {
      resources: {
          'billing-letter': ['list', 'edit'],
          'refunds': ['list'],
          'purchase-orders': ['list'],
          'reports': ['consultant'],
          'consultants': ['list', 'edit' , 'public'],
          'companies': ['list', 'new', 'group', 'match', 'temporary-list', 'temporary-new'],
          'products': ['list', 'new', 'edit'],
      },
      commonResources: ['billing-letter', 'companies', 'products', 'purchase-orders', 'refunds', 'reports']
    },
    [GUARDS.ADMINISTRATIVE_2]: {
      resources: {
        'purchase-orders': ['list', 'new', 'edit','upload'],
        'reports': ['consultant'],
        'companies': ['list', 'new']
      },
      commonResources: ['purchase-orders', 'reports', 'companies', 'projects']
    },
    [GUARDS.BILLSRECEIVE]: {
      resources: {
        'billing-letter': ['list', 'new', 'edit', 'upload'],
        'purchase-orders': ['list', 'new', 'edit', 'hierarchy','upload'],
        'companies': ['list', 'new', 'edit', 'group', 'temporary-list'],
        'projects': ['list', 'edit'],
        'products': ['list', 'new', 'edit'],
        'cnaes': ['list', 'new', 'edit'],
        'refunds': ['list'],
      },
      commonResources: ['billing-letter', 'purchase-orders', 'cnaes', 'companies', 'projects', 'products']
    },
    [GUARDS.COMMERCIAL]: {
      resources: {
        'dashboard': ['list'],
        'billing-letter': ['list', 'edit'],
        'approvals': ['list'],
        'companies': ['list', 'new', 'edit', 'group', 'inventory-list', 'company-inventory-edit', 'company-products-list', 'company-products-new', 'company-products-edit'],
        'consultants': ['list', 'edit'],
        'reports': ['consultant', 'byproject', 'billing-letter'],
        'projects': ['list','edit'],
        'products': ['list'],
        'purchase-orders': ['list', 'new', 'edit','upload'],
        'refunds': ['list', 'edit']
      },
      commonResources: ['billing-letter', 'approvals', 'companies', 'consultants', 'projects', 'products']
    },
    [GUARDS.DP]: {
      resources: {
        'refunds': ['list', 'edit'],
        'purchase-orders': ['list', 'new', 'edit','upload'],
        'companies': ['list', 'new'],
        'consultants': ['list', 'new', 'edit', 'upload'],
        'reports': ['consultant'],
        'approvals': ['list', 'new', 'edit', 'upload'],

      },
      commonResources: ['consultants', 'reports', 'purchase-orders', 'refunds', 'approvals']
    },
    [GUARDS.FINANCES]: {
      resources: {
        'billing-letter': ['list', 'new', 'edit', 'upload'],
        'approvals': ['list', 'new', 'edit'],
        'refunds': ['list', 'edit'],
        'purchase-orders': ['list', 'new', 'edit', 'upload'],
        'companies': ['list', 'new', 'edit', 'group'],
        'consultants': ['list', 'new', 'edit'],
        'reports': ['consultant', 'byproject', 'billing-letter'],
        'projects': ['list', 'edit'],
        'projects-cost': ['list', 'new', 'edit'],
        'products': ['list'],
        'cnaes': ['list', 'new', 'edit']
      },
      commonResources: ['billing-letter', 'approvals', 'refunds', 'consultants', 'reports', 'purchase-orders', 'projects']
    },
    [GUARDS.GOVERNANCE]: {
      resources: {
        'log': ['list'],
        'notifications': ['list'],
        'dashboard': ['list'],
        'billing-letter': ['list', 'new', 'edit', 'upload'],
        'approvals': ['list', 'new', 'edit'],
        'refunds': ['list', 'edit'],
        'purchase-orders': ['list', 'new', 'edit', 'hierarchy','upload'],
        'companies': ['list', 'new', 'edit', 'group', 'match', 'temporary-list', 'temporary-new', 'company-inventory-new', 'company-inventory-edit', 'inventory-list', 'company-products-list', 'company-products-new', 'company-products-edit'],
        'consultants': ['list', 'new', 'edit', 'partners', 'teamGroup-list', 'teamGroup-new', "teamGroup-edit", 'upload', 'relocation-list', 'relocation-new', 'relocation-edit'],
        'reports': ['consultant', 'byproject', 'billing-letter', 'distract'],
        'projects': ['list', 'new', 'edit'],
        'projects-cost': ['list', 'new', 'edit'],
        'products': ['list', 'new', 'edit'],
        'cnaes': ['list', 'new', 'edit'],
        'users': ['list', 'new', 'edit'],
      },
      commonResources: ['billing-letter', 'approvals', 'refunds', 'consultants', 'reports', 'projects']
    },
    [GUARDS.INFRA]: {
      resources: {
        'purchase-orders': ['list', 'new', 'edit','upload'],
        'consultants': ['list', 'edit', 'public'],
        'companies': ['list', 'new'],
        'reports': ['consultant'],
        'users': ['list', 'new', 'edit']
      },
      commonResources: ['consultants', 'reports', 'purchase-orders', 'users']
    },
    [GUARDS.JUDICIARY]: {
      resources: {
        'dashboard': ['list'],
        'purchase-orders': ['list', 'new', 'edit','upload'],
        'companies': ['list', 'edit', 'temporary-list', 'temporary-new', 'inventory-list', 'company-inventory-new', 'company-inventory-edit', 'vendor-inventory-list', 'vendor-inventory-new', 'vendor-inventory-edit', 'company-products-list', 'company-products-new', 'company-products-edit'],
        'consultants': ['list', 'new', 'edit', 'public'],
        'reports': ['consultant', 'distract'],
        'users': ['list', 'new', 'edit'],
        'projects': ['list', 'edit'],
        'refunds': ['list', 'edit']
      },
      commonResources: ['consultants', 'reports', 'companies', 'purchase-orders', 'users']
    },
    [GUARDS.MANAGER]: {
      resources: {
        'log': ['list'],
        'notifications': ['list'],
        'dashboard': ['list'],
        'billing-letter': ['list', 'new', 'edit', 'upload'],
        'approvals': ['list', 'new', 'edit'],
        'refunds': ['list', 'edit'],
        'purchase-orders': ['list', 'new', 'edit', 'hierarchy','upload'],
        'companies': ['list', 'new', 'edit', 'group', 'match', 'temporary-list', 'temporary-new', 'inventory-list', 'company-inventory-edit'],
        'consultants': ['list', 'new', 'edit', 'teamGroup-list', 'teamGroup-new', "teamGroup-edit", "archives",],
        'reports': ['consultant', 'byproject', 'billing-letter'],
        'projects': ['list', 'edit'],
        'projects-cost': ['list', 'new', 'edit'],
        'products': ['list', 'new', 'edit'],
        'cnaes': ['list', 'new', 'edit'],
      },
      commonResources: ['purchase-orders', 'billing-letter', 'approvals', 'refunds', 'consultants', 'companies', 'projects']
    },
    [GUARDS.RS]: {
      resources: {
        'purchase-orders': ['list', 'new', 'edit','upload'],
        'companies': ['list'],
        'consultants': ['list', 'edit', 'public', 'partners', 'relocation-list', 'relocation-new', 'relocation-edit'],
        'reports': ['consultant', 'byproject'],
        'projects': ['list', 'edit'],
      },
      commonResources: ['purchase-orders', 'companies', 'consultants', 'reports', 'projects']
    },
    [GUARDS.PEOPLE]: {
      resources: {
        'dashboard': ['distracts'],
        'refunds': ['list', 'edit'],
        'approvals': ['list'],
        'purchase-orders': ['list', 'edit'],
        'consultants': ['list', 'edit', 'public', 'partners', 'relocation-list', 'relocation-new', 'relocation-edit'],
        'reports': ['consultant', 'distract'],
      },
      commonResources: ['consultants', 'reports', 'refunds']
    },
    [GUARDS.CONTROLLERSHIP]: {
      resources: {
        'dashboard': ['distracts'],
        'billing-letter': ['list', 'edit'],
        'approvals': ['list'],
        'companies': ['list'],
        'consultants': ['list', 'edit'],
        'purchase-orders': ['list', 'new', 'edit','upload'],
        'projects-cost': ['list', 'new', 'edit'],
        'refunds': ['list', 'edit'],
        'reports': ['byproject' , 'consultant'],
        'projects': ['list', 'edit'],
      },
      commonResources: ['billing-letter', 'reports', 'approvals', 'purchase-orders', 'projects', 'companies']
    },
    [GUARDS.BUSINESSPARTNER]: {
      resources: {
        'consultants': ['list', 'edit', 'relocation-list', 'relocation-new', 'relocation-edit'],
        'reports': ['consultant'],
        'projects': ['list', 'edit'],
        'approvals': ['list'],

      },
      commonResources: ['consultants', 'reports', 'projects', 'approvals']
    },
    [GUARDS.TECHMANAGEMENT]: {
      resources: {
        'billing-letter': ['list', 'edit'],
        'consultants': ['list', 'edit'],
        'reports': ['consultant'],
        'projects': ['new', 'edit', 'list'],
      },
      commonResources: [ 'consultants', 'billing-letter', 'reports']
    },
    [GUARDS.ACCOUNTMANAGER]: {
      resources: {
        'billing-letter': ['list', 'edit'],
        'companies': ['list', 'edit', 'inventory-list', 'company-inventory-edit', 'temporary-list'],
        'projects': ['new', 'edit', 'list'],
      },
      commonResources: ['billing-letter', 'companies']
    },
    [GUARDS.PMO]: {
        resources: {
          'consultants': ['list', 'edit', 'teamGroup-list', 'teamGroup-new', 'teamGroup-edit'],
          'projects': ['list', 'new', 'edit'],
          'billing-letter': ['list', 'edit'],
          'approvals': ['list'],
          'reports': ['byproject', 'consultant'],
          'companies': ['list']
        },
        commonResources: ['consultants', 'reports', 'projects', 'approvals', 'companies', 'billing-letter']
    },
    [GUARDS.ACCOUNTING]: {
        resources: {
          'approvals': ['list', 'edit'],
          'billing-letter': ['list', 'edit'],
          'companies': ['list'],
          'consultants': ['list', 'new', 'edit'],
          'cnaes': ['list', 'new', 'edit'],
          'products': ['list'],
          'purchase-orders': [ 'new', 'list', 'edit'],
          'reports': ['consultant', 'byproject'],
          'projects': ['list', 'new', 'edit'],
          'refunds': ['list', 'edit'],
          'accounting-block': ['blockup']
        },
        commonResources: ['billing-letter', 'companies', 'approvals', 'consultants', 'purchase-orders', 'accounting-block', 'projects']
    },
  };



// WEBPACK FOOTER //
// ./src/app/shared/auth/Roles.ts